// COPIED from ptc-core web/src/shell/notifications/useReadOnArrival.ts @ 998eb0a (unchanged since 98ca2bc), verbatim (fleet staff notifications, spec
// v0.2 §5, conformance N4). Mounted once in AppLayout, so it works on every route of this app.
// Read-on-arrival (fleet staff notifications, spec v0.2 §5, conformance N4): a notification's link carries ?n=<id>, and
// the page it opens marks that notification read. Run once in the app shell, so it works on every route, however the
// link was followed (a plain click, a new tab, a link pasted in mail). Afterwards `n` is removed from the URL with
// `replace`, so Back, a refresh or a copied link never repeats it and the list state in the URL is left as it was.
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useMarkNotificationRead } from '../../api/notifications';

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function useReadOnArrival(): void {
  const [params, setParams] = useSearchParams();
  const markRead = useMarkNotificationRead();
  const done = useRef<string | null>(null);
  const n = params.get('n');

  useEffect(() => {
    if (!n || done.current === n) return;
    done.current = n;
    if (GUID.test(n)) markRead.mutate(n);
    const next = new URLSearchParams(params);
    next.delete('n');
    setParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- once per arriving id; params/setParams change with it
  }, [n]);
}
